(() => {
  const PROFILE_REFRESH_ATTEMPTS = 15;
  const PROFILE_REFRESH_INTERVAL_MS = 1000;
  const mounts = [...document.querySelectorAll('[data-zj-customer-avatar]')];
  if (!mounts.length) return;

  const fallback = (initials) => {
    if (initials) return document.createTextNode(initials);
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = '<circle cx="12" cy="8" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/>';
    return svg;
  };

  const render = (mount, profile) => {
    mount.replaceChildren();
    if (profile?.avatarUrl) {
      const image = document.createElement('img');
      image.src = profile.avatarUrl;
      image.alt = profile.avatarAlt || profile.displayName || '';
      image.addEventListener('error', () => { mount.replaceChildren(fallback(profile.initials)); }, { once: true });
      mount.append(image);
    } else mount.append(fallback(profile?.initials || ''));
    mount.hidden = false;
  };

  const load = async () => {
    try {
      const mount = mounts[0];
      const endpoint = new URL(mount.dataset.endpoint, window.location.origin);
      endpoint.searchParams.set('section', 'profile');
      endpoint.searchParams.set('locale', document.documentElement.lang || 'en');
      const response = await fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.profile) return null;
      mounts.forEach((target) => render(target, result.profile));
      return result.profile;
    } catch {
      // The native Shopify account control remains available as the safe fallback.
      return null;
    }
  };

  const refreshProcessingAvatar = async (avatarId) => {
    for (let attempt = 0; attempt < PROFILE_REFRESH_ATTEMPTS; attempt += 1) {
      await new Promise((resolve) => window.setTimeout(resolve, PROFILE_REFRESH_INTERVAL_MS));
      const profile = await load();
      if (!profile) continue;
      if (profile.avatarId !== avatarId || profile.avatarUrl) return;
    }
  };

  void load().then((profile) => {
    if (
      profile?.processing &&
      profile.avatarId &&
      !document.querySelector('[data-zj-my-business]')
    ) void refreshProcessingAvatar(profile.avatarId);
  });
  document.addEventListener('project-zj:customer-avatar-updated', (event) => {
    if (!event.detail?.profile) return;
    mounts.forEach((mount) => render(mount, event.detail.profile));
  });
})();
